import { render, staticRenderFns } from "./AiFinance.vue?vue&type=template&id=5d5f1517&scoped=true"
import script from "./AiFinance.vue?vue&type=script&lang=js"
export * from "./AiFinance.vue?vue&type=script&lang=js"
import style0 from "./AiFinance.vue?vue&type=style&index=0&id=5d5f1517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f1517",
  null
  
)

export default component.exports